export default "__VITE_ASSET__BLigIL$y__"